import { Table, TableProps } from 'libs/ui';
import { CSSObject, styled } from 'libs/ui/styled';
import { Colors } from 'libs/ui/theme';

import { NotificationSettingsTableItem } from './types';

export const NotificationSettingsTableStyled = styled(
  (props: TableProps<NotificationSettingsTableItem, ''>) => (
    <Table columnHeaderHeight={44} rowHeight={44} {...props} />
  )
)(() => ({
  '.table-dataGrid': {
    border: `1px solid ${Colors.gray200}`,
    borderRadius: 9,
    '.table-columnHeaders': {
      background: 'none',
      borderRadius: 0,
      borderBottom: `1px solid ${Colors.gray200}`,

      '.table-columnHeader:not(:last-child)': {
        borderRight: `1px solid ${Colors.gray200}`,
      } as CSSObject,
    } as CSSObject,

    '.table-cell:not(:last-child)': {
      borderRight: `1px solid ${Colors.gray200}`,
    } as CSSObject,
  } as CSSObject,
}));
